
import React from 'react'
import { Link } from "react-router-dom";
import { connect } from 'react-redux';
import Icon from 'react-icons-kit';
import {chevronRight} from 'react-icons-kit/fa/chevronRight';

import * as actions from '../../store/actions';
import SubPageList from '../SubPageList';

import styles from './SubPageListItem.module.css';

const SubPageListItem = props => {

  const {page, navLevel = 0, setCurrentPage} = props;

  if (!page) return null;

  const hasSubpages = page.subpages && page.subpages.length > 0;

  return (
    <li className={styles.SubPageListItem}>
      {/* The href on its own changes nothing: ReadingPane reads the page out of
         pages.currentPage and never looks the slug up off the URL, so the dispatch
         is what actually swaps the content. */}
      <Link className={styles.Link} to={'/manual/' + page.slug} onClick={() => setCurrentPage(page.slug)}>
        <Icon className={styles.Chevron} size={12} icon={chevronRight}/>
        <span className={styles.LinkText}>{page.title}</span>
      </Link>
      { hasSubpages ? <SubPageList pagelist={page.subpages} navLevel={navLevel} /> : null }
    </li>
  )
}

const mapStateToProps = ({pages}, ownProps) => {
  return {
      page: pages.pages ? pages.pages[ownProps.id] : false
  }
}
const mapDispatchToProps = dispatch => {
  return {
      setCurrentPage: (slug) => dispatch(actions.setCurrentPage(slug))
  }
}

export default connect(mapStateToProps,mapDispatchToProps)(SubPageListItem)
